/* eslint-disable default-param-last */
const intervals = {};

export default function setupDataFetcher(
  onResult,
  onError,
  generateFetchKey,
  refreshInterval = null,
  propParams
) {
  const params = propParams || {}; // cant set default propParams in args, otherwise causes rerenders
  const baseFetchKey = generateFetchKey();
  const fetchKeyWithParams = generateFetchKey(params);
  const interval = intervals[fetchKeyWithParams];
  // clear out old subscriptions if running this again (params change, etc.)
  window.UNSUBSCRIBE(`fetch_result_${fetchKeyWithParams}`, onResult);
  window.UNSUBSCRIBE(`fetch_error_${fetchKeyWithParams}`, onError);

  // clear out old interval is running this again
  if (interval) {
    clearInterval(interval);
  }

  // setup subscriptions
  window.SUBSCRIBE(`fetch_result_${fetchKeyWithParams}`, onResult);
  window.SUBSCRIBE(`fetch_error_${fetchKeyWithParams}`, onError);
  // request data
  window.PUBLISH(`fetch_get_${baseFetchKey}`, { params });

  // setup data refreshing interval
  if (refreshInterval) {
    intervals[fetchKeyWithParams] = setInterval(() => {
      window.PUBLISH(`fetch_get_${baseFetchKey}`, { params });
    }, refreshInterval);
  }

  return () => {
    window.UNSUBSCRIBE(`fetch_result_${fetchKeyWithParams}`, onResult);
    window.UNSUBSCRIBE(`fetch_error_${fetchKeyWithParams}`, onError);
    clearInterval(intervals[fetchKeyWithParams]);
  };
}
